"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryActionType = exports.PolicyAdjustmentType = exports.PolicyProjectType = void 0;
var PolicyProjectType;
(function (PolicyProjectType) {
    PolicyProjectType["TRAVEL_POLICY_PROJECT"] = "TRAVEL_POLICY_PROJECT";
    PolicyProjectType["LEAVE_POLICY_PROJECT"] = "LEAVE_POLICY_PROJECT";
    PolicyProjectType["CUSTOM_POLICY_PROJECT"] = "CUSTOM_POLICY_PROJECT";
    PolicyProjectType["DIVERSITY_INCLUSION_POLICY_PROJECT"] = "DIVERSITY_INCLUSION_POLICY_PROJECT";
    PolicyProjectType["REMOTE_WORK_POLICY_PROJECT"] = "REMOTE_WORK_POLICY_PROJECT";
    PolicyProjectType["PERFORMANCE_EVALUATION_POLICY_PROJECT"] = "PERFORMANCE_EVALUATION_POLICY_PROJECT";
    PolicyProjectType["EMPLOYEE_BENEFITS_POLICY_PROJECT"] = "EMPLOYEE_BENEFITS_POLICY_PROJECT";
    PolicyProjectType["SALARY_COMPENSATION_POLICY_PROJECT"] = "SALARY_COMPENSATION_POLICY_PROJECT";
    PolicyProjectType["OVERTIME_POLICY_PROJECT"] = "OVERTIME_POLICY_PROJECT";
    PolicyProjectType["SEXUAL_HARASSMENT_POLICY_PROJECT"] = "SEXUAL_HARASSMENT_POLICY_PROJECT";
    PolicyProjectType["NON_DISCRIMINATION_POLICY_PROJECT"] = "NON_DISCRIMINATION_POLICY_PROJECT";
    PolicyProjectType["WORKPLACE_HARASSMENT_POLICY_PROJECT"] = "WORKPLACE_HARASSMENT_POLICY_PROJECT";
    PolicyProjectType["PARENTAL_LEAVE_POLICY_PROJECT"] = "PARENTAL_LEAVE_POLICY_PROJECT";
    PolicyProjectType["TERMINATION_POLICY_PROJECT"] = "TERMINATION_POLICY_PROJECT";
    PolicyProjectType["WHISTLEBLOWER_PROTECTION_POLICY_PROJECT"] = "WHISTLEBLOWER_PROTECTION_POLICY_PROJECT";
    PolicyProjectType["VACATION_HOLIDAY_POLICY_PROJECT"] = "VACATION_HOLIDAY_POLICY_PROJECT";
    PolicyProjectType["MATERNITY_LEAVE_POLICY_PROJECT"] = "MATERNITY_LEAVE_POLICY_PROJECT";
    PolicyProjectType["WORK_LIFE_BALANCE_POLICY_PROJECT"] = "WORK_LIFE_BALANCE_POLICY_PROJECT";
    PolicyProjectType["SICK_LEAVE_POLICY_PROJECT"] = "SICK_LEAVE_POLICY_PROJECT";
    PolicyProjectType["HEALTH_SAFETY_POLICY_PROJECT"] = "HEALTH_SAFETY_POLICY_PROJECT";
    PolicyProjectType["EXPENSE_REIMBURSEMENT_POLICY_PROJECT"] = "EXPENSE_REIMBURSEMENT_POLICY_PROJECT";
    PolicyProjectType["EQUAL_EMPLOYMENT_OPPORTUNITY_POLICY_PROJECT"] = "EQUAL_EMPLOYMENT_OPPORTUNITY_POLICY_PROJECT";
})(PolicyProjectType || (exports.PolicyProjectType = PolicyProjectType = {}));
var PolicyAdjustmentType;
(function (PolicyAdjustmentType) {
    PolicyAdjustmentType["UPDATE_ADJUSTMENT"] = "UPDATE_ADJUSTMENT";
    PolicyAdjustmentType["REVERT_ADJUSTMENT"] = "REVERT_ADJUSTMENT";
})(PolicyAdjustmentType || (exports.PolicyAdjustmentType = PolicyAdjustmentType = {}));
var HistoryActionType;
(function (HistoryActionType) {
    HistoryActionType["CREATE_FROM_TYPE"] = "CREATE_FROM_TYPE";
    HistoryActionType["CREATE_FROM_FILE"] = "CREATE_FROM_FILE";
    HistoryActionType["CREATE_FROM_LINK_RECORD"] = "CREATE_FROM_LINK_RECORD";
    HistoryActionType["ADJUSTMENT_UPDATE"] = "ADJUSTMENT_UPDATE";
    HistoryActionType["PROMPT_UPDATE"] = "PROMPT_UPDATE";
    HistoryActionType["GENERATE_CONFLICTS"] = "GENERATE_CONFLICTS";
    HistoryActionType["GENERATE_COMPLIANCE"] = "GENERATE_COMPLIANCE";
    HistoryActionType["ADJUSTMENT_REVERT"] = "ADJUSTMENT_REVERT";
    HistoryActionType["CONTENT_UPDATE"] = "CONTENT_UPDATE";
})(HistoryActionType || (exports.HistoryActionType = HistoryActionType = {}));
